export default __webpack_public_path__ + "static/media/EmeraldIcon1.62e38986.svg";